import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import cx from 'classnames2';
import React from 'react';
import { Icon } from '../Icon';
import styles from './Pill.scss';
export var Pill = function Pill(props) {
  return props.onClick ? DualPill(props) : SinglePill(props);
};

var DualPill = function DualPill(props) {
  return React.createElement("div", {
    className: cx(styles.pill, _defineProperty({}, styles.small, props.size === 'small'))
  }, React.createElement("button", {
    className: styles.primaryButton,
    title: props.text,
    onClick: props.onClick
  }, props.icon && React.createElement(Icon, {
    icon: props.icon,
    ariaLabel: props.iconAriaLabel,
    className: styles.primaryIcon
  }), React.createElement("span", {
    className: styles.text
  }, props.text)), React.createElement("button", {
    "aria-label": "remove",
    className: styles.secondaryButton,
    onClick: props.onRemove
  }, React.createElement(Icon, {
    icon: "action-close-small",
    ariaLabel: "Remove filter"
  })));
};

var SinglePill = function SinglePill(props) {
  return React.createElement("div", {
    className: styles.single
  }, React.createElement("button", {
    "aria-label": "remove",
    className: cx(styles.singleButton, _defineProperty({}, styles.small, props.size === 'small')),
    title: props.text,
    onClick: props.onRemove
  }, React.createElement("span", {
    className: styles.textContainer
  }, props.icon && React.createElement(Icon, {
    icon: props.icon,
    ariaLabel: props.iconAriaLabel,
    className: styles.primaryIcon
  }), React.createElement("span", {
    className: styles.text
  }, props.text)), React.createElement(Icon, {
    className: styles.icon,
    icon: "action-close-small",
    ariaLabel: "Remove filter"
  })));
};